import React from 'react';
import notfound from '../../images/not-found/notfound.webp'
const NotFound = () => {
    return (
        <div>
            <img src={notfound} alt="" />
        </div>
    );
};

export default NotFound;